const can = (user, perm) => {
  return !!(user && user.permissions && user.permissions.find(p => p === perm))
}

export const canManageJob = user => can(user, 'manage-job')
export const canManageComment = user => can(user, 'manage-comment')
export const canBlockUser = user => can(user, 'block-user')
export const canBlockBid = user => can(user, 'block-bid')
